// window.addEventListener("load", function () {
//   document.querySelectorAll("[data-truncate]").forEach(function (element) {
//     element.addEventListener("click", function (event) {
//       if (!event.target.matches("a, a *")) {
//         event.preventDefault();

//         var shortElement = document.querySelector(".truncate__short");
//         var longElement = document.querySelector(".truncate__long");

//         if (shortElement.classList.contains("active")) {
//           shortElement.classList.remove("active");
//           longElement.classList.add("active");
//         } else {
//           shortElement.classList.add("active");
//           longElement.classList.remove("active");
//         }
//       }
//     });
//   });
// });


$(function() {
  var Accordion = function(el, multiple) {
  this.el = el || {};
  this.multiple = multiple || false;

    var links = this.el.find('.product-title');
    links.on('click', {
      el: this.el,
      multiple: this.multiple
    }, this.dropdown)
  }

  Accordion.prototype.dropdown = function(e) {
    var $el = e.data.el;
    $this = $(this),
    $next = $this.next();
  
    $next.slideToggle();
    $this.parent().toggleClass('open');
  
    if (!e.data.multiple) {
      $el.find('.product-detail-content').not($next).slideUp().parent().removeClass('open');
    };
  }
  var accordion = new Accordion($('.product-detail-accordion-main'), false);
});

$('.slider-gallery-main').slick({
  slidesToShow: 5,
  slidesToScroll: 1,
  arroes: true,
  dots: false,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        arrows: false,
        centerMode: true,
        centerPadding: '40px',
        slidesToShow: 3
      }
    },
    {
      breakpoint: 480,
      settings: {
        arrows: false,
        centerMode: true,
        centerPadding: '40px',
        slidesToShow: 1
      }
    }
  ]
});

jQuery(document).ready(function(jQuery){
  
  jQuery(".product-thumbnail .product-thumbnail__title").each(function () {
    function e() {
      jQuery(".product-thumbnail .product-thumbnail__title").css("height", "auto");
      var e = -1;
      jQuery(".product-thumbnail .product-thumbnail__title").each(function () {
        var t = jQuery(this).outerHeight();
        e = t > e ? t : e
      }), jQuery(".product-thumbnail .product-thumbnail__title").css("height", e)
    }
    jQuery(this), jQuery(window).on("load resize orientationchange", e)
  });

 $(".readmore_btn").click(function(){
    $(this).toggleClass("active-btn");
    $(".product_description_part_small").toggleClass("active");    
});

});

document.addEventListener("DOMContentLoaded", function() {
  const ticker = document.querySelector('.horizontal-ticker');
  const startDateStr = ticker.getAttribute('data-startdate'); 
  const endDateStr = ticker.getAttribute('data-enddate'); 

  // Convert the start and end dates to PST using toLocaleString
  const startDatePST = new Date(new Date(startDateStr.replace(' ', 'T') + '-08:00').toLocaleString("en-US", { timeZone: "America/Los_Angeles" }));
  const endDatePST = new Date(new Date(endDateStr.replace(' ', 'T') + '-08:00').toLocaleString("en-US", { timeZone: "America/Los_Angeles" }));

  // Get the current time in local timezone
  const currentDateLocal = new Date();
  
  // Convert current time to PST
  const currentDatePST = new Date(currentDateLocal.toLocaleString("en-US", { timeZone: "America/Los_Angeles" }));

  if (currentDatePST >= startDatePST && currentDatePST < endDatePST) {
    document.querySelector('.black-friday__banner').classList.remove('hide');
    document.querySelector('.skinacare__banner').classList.add('hide');
  } else {
    document.querySelector('.skinacare__banner').classList.remove('hide');
    document.querySelector('.black-friday__banner').classList.add('hide');
  }
});